import styled from "styled-components/macro";

export const StyledStars = styled.div`
  position: absolute;
  left: 407px;
  top: 5px;
  z-index: -2;
  transform: scale(0.8);
  width: 100px;
  height: 100px;
  overflow: visible;
  opacity: 0;
  transition: all 300ms;
  path {
    fill: var(--primary-cta);
  }
  ${({ isKept }) => (isKept ? "opacity:1;" : "")}

  svg {
    transition: all 300ms;
    &:nth-child(1) {
      transform: translate(0, -20px) rotate(10deg);
    }
    &:nth-child(2) {
      transform: translate(10px, 33px) rotate(50deg);
    }
    &:nth-child(3) {
      transform: translate(-18px, 0) rotate(30deg);
    }
  }

  &.shooting {
    transition: all 400ms;
    transform: translate(20px) scale(1);
    top: -12px;
    left: 418px;
    opacity: 1;
  }
`;

export const StyledTUDecoy = styled.div`
  width: 458px;
  height: 100px;
  ${({ kept }) => (kept ? "" : "border: 1px solid #e6e6e6")};
  border-radius: 10px;
  background: var(--menu-color-fullscreen);

  ${({ side, kept }) => (side === "right" && !kept ? "margin-left:-229px;" : "")}
`;

export const StyledTUDecoyLeft = styled.div`
  width: 76px;
  border-right: 1.5px solid var(--divider);
  float: left;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  cursor: pointer;
  &:hover {
    background: rgba(158, 158, 158, 0.2);
  }
  &:active {
    background: rgba(158, 158, 158, 0.4);
  }
  svg {
    margin-top: 30px;
    transition: all 300ms;
  }
`;

export const StyledTUDecoyRight = styled.div`
  width: 76px;
  border-left: 1.5px solid var(--divider);
  float: right;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
  &:hover {
    background: rgba(158, 158, 158, 0.2);
  }
  &:active {
    background: rgba(158, 158, 158, 0.4);
  }

  svg {
    margin-top: 25px;
    transition: all 300ms;
  }
`;

export const StyledTUDecoyMiddle = styled.div`
  width: 280px;
  padding-left: 10px;
  padding-right: 10px;
  color: var(--grey-0);
  font-family: "Inter";
  text-align: ${({ length }) => (length > 120 ? "left" : "center")};

  ${({ length }) => length <= 9 && "font-size: 55px;"};
  ${({ length }) => length > 9 && length <= 11 && "font-size:50px;"};
  ${({ length }) => length > 11 && length <= 18 && "font-size: 32px;"};
  ${({ length }) => length > 18 && length <= 35 && "font-size: 28px;"};
  ${({ length }) => length > 35 && length <= 50 && "font-size: 24px;"};
  ${({ length }) => length > 50 && length <= 65 && "font-size: 20px;"};
  ${({ length }) => length > 65 && length <= 100 && "font-size: 18px;"};
  ${({ length }) => length > 90 && "text-align: justify;"};
  ${({ length }) => length > 100 && length <= 150 && "font-size: 16px;"};
  ${({ length }) => length > 150 && length <= 180 && "font-size: 14px;"};
  ${({ length }) => length > 180 && "font-size: 13px;"};

  display: flex;
  align-items: center;
  justify-content: center;
  height: inherit;
`;

export const StyledTUDecoyHalf = styled.div`
  box-sizing: border-box;
  ${({ kept }) => !kept && "width:229px;"}
  overflow: hidden;
  position: absolute;
  ${({ kept }) => (kept ? "transition: all 0s;" : "transition: all 300ms;")}
  top: 0;
  ${({ side }) => side === "left" && "left: 0;"}
  ${({ side, kept }) => (side === "right" && !kept ? "right: 0; margin-left:-229px;" : "")}
`;

export const StyledTUDecoyContainer = styled.div`
  overflow: visible;
  position: relative;
  margin-left: 4px;
  width: 458px;
  height: 0px;
  transition: all 200ms;
  margin-top: 0px;
  background: var(--menu-color-fullscreen);
  border-radius: 10px;

  ${({ top }) => top && `top: ${top}px;`}
  ${({ left }) => left && `left: ${left}px;`}
  ${({ born }) => (born ? "height: 100px; margin-top: 22px;" : "")}
  /* ${({ broken }) => (broken ? "" : "box-shadow: 0 2px 4px #aaa;")} */

  &.startKeepAnimation {
    transition: all 0s;
    filter: var(--chip-drop-shadow-filter);
    /* box-shadow: var(--chip-drop-shadow); */
    transform: scale(1.05);

    ${StyledTUDecoyRight} {
      background: rgba(158, 158, 158, 0.4);
    }
  }

  &.closeIt {
    transition: all 600ms;
    opacity: 0;
    z-index: 0;
  }

  &.thumbsFade {
    filter: var(--chip-drop-shadow-filter);
    /* box-shadow: var(--chip-drop-shadow); */
    ${StyledTUDecoyRight},${StyledTUDecoyLeft} {
      transition: all 200ms;
      opacity: 0;
    }
  }

  &.marginsAnimateOut {
    filter: var(--chip-drop-shadow-filter);
    /* box-shadow: var(--chip-drop-shadow); */
    transition: all 200ms;
    width: 360px;

    ${StyledTUDecoyMiddle} {
      margin-left: 80px;
    }

    ${StyledTUDecoyRight} {
      background: var(--menu-color-fullscreen);
    }

    ${StyledTUDecoyRight},${StyledTUDecoyLeft} {
      transition: all 300ms;
      width: 0;
      opacity: 0;
    }
  }

  &.repositionKeptCard {
    transition: all 300ms;
    ${StyledTUDecoyRight},${StyledTUDecoyLeft},${StyledStars} {
      display: none;
    }

    ${StyledTUDecoy} {
      ${({ smaller }) => (smaller ? "width:563px;" : " width: 591px;")}
      position: relative;
      height: auto;
      border-radius: 20px;
    }

    ${StyledTUDecoyMiddle} {
      transition: all 140ms; //faster so text gets to the right size before the animation ends
      ${({ smaller }) => (smaller ? "width:563px;" : " width: 591px;")}
      position: relative;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 8px;
      ${({ contentLength }) => (contentLength > 32 ? "padding-top:15px;" : "padding-top:0px;")}
      font-size: 36px;
      min-height: 90px;
      line-height: 36px;
    }

    ${StyledTUDecoyHalf} {
      ${({ smaller }) => (smaller ? "width:563px;" : " width: 591px;")}
      padding-bottom: 0;

      span {
        transition: all 300ms;
        text-align: left;
        width: inherit;
        height: auto;
        padding: 20px;
        padding-top: 2px;
        ${({ contentLength }) => (contentLength > 32 ? "padding-bottom:16px;" : "padding-bottom:0px;")}
        ${({ contentLength }) => (contentLength > 32 ? "" : "margin-top: -16px;")}
      }
    }

    /* filter: drop-shadow(0 2px 4px #aaa); */
    /* box-shadow: var(--chip-drop-shadow); */
    ${({ smaller }) => (smaller ? "top:23px;" : "top: 23px;")}
    ${({ smaller }) => (smaller ? "left:-139px;" : "left: -146px;")}
    transform: scale(0.5);
    ${({ smaller }) => (smaller ? "width:563px;" : "width: 591px;")}
    min-height: 90px;
    height: auto;
    border-radius: 20px;
    padding: 0;
    height: auto;
    position: absolute;
  }

  ${StyledTUDecoyRight} {
    background: rgba(158, 158, 158, 0.4);
  }
`;
